import { Accordion, AccordionDetails, AccordionSummary, Box, Button, Typography } from "@mui/material";
import ErrorIcon from "@mui/icons-material/Error";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ModeEditOutlineOutlinedIcon from "@mui/icons-material/ModeEditOutlineOutlined";
import AddIcon from "@mui/icons-material/Add";
import KeyboardArrowDownOutlinedIcon from "@mui/icons-material/KeyboardArrowDownOutlined";
import KeyboardArrowUpOutlinedIcon from "@mui/icons-material/KeyboardArrowUpOutlined";
import { memo, useEffect, useState } from "react";
import { useLocation, useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { fetchProductBasicById, fetchProductImageUrl } from "middleware/services/productApi";
import { setProductDetails } from "middleware/actions/productAction";
import VideosTable from "./videos";
import { accessRightActionCheck, getProductVariant } from "utilities";
import { actionError, hideLoader, showLoader } from "middleware/actions/utilityAction";
import PropTypes from "prop-types";
import { showAlertBox } from "middleware/actions/alertBoxAction";
import DocumentTable from "./documents-brochure";
import ImageTable from "./images";
import { COMMON_ACCESS_ACTION } from "constants";

const ProductOverview = (props) => {
  const { accessRights: aR } = props;
  const { onSaveProcessingData, onFinalSaveProcessingData } = props;
  const [expandedAccordions, setExpandedAccordions] = useState({
    productDescription: false,
    documents: false,
    videos: false,
    images: false,
  });
  const [interfaceActionAccessOverview, setInterfaceActionAccessOverview] = useState([]);

  /* Common access */
  const accessActionSave = interfaceActionAccessOverview.includes(COMMON_ACCESS_ACTION.SAVE);
  const accessActionSubmit = interfaceActionAccessOverview.includes(COMMON_ACCESS_ACTION.SUBMIT);
  const accessActionFinalSubmit = interfaceActionAccessOverview.includes(COMMON_ACCESS_ACTION.FINAL_SUBMIT);

  const history = useHistory();
  const location = useLocation();
  const split_url = location.pathname.split("/");
  split_url.pop();
  const productVariant = getProductVariant();
  const { productDetails } = useSelector((state) => state.productState);
  const dispatch = useDispatch();
  const handleAccordionChange = (panel) => {
    setExpandedAccordions((prev) => ({
      ...prev,
      [panel]: !expandedAccordions[panel],
    }));
  };

  const saveProductData = async () => {
    dispatch(
      showAlertBox({
        okCallback: async () => {
          props.editData
            ? onSaveProcessingData("overview")
            : onSaveProcessingData("overview", {
                productId: result.productId,
              });
        },
        content: "Are you sure you want to save?",
        okText: "Save",
        cancelText: "Cancel",
        title: "dialogAlertCss",
      })
    );
  };

  const getProductDetails = async () => {
    try {
      dispatch(showLoader());
      const productId = props.productId || props.computedMatch.params?.productId;
      const response = await fetchProductBasicById(productId);
      if (response?.data?.data) dispatch(setProductDetails(response.data.data));
    } catch (error) {
      dispatch(actionError("Something Went Wrong while processing."));
    } finally {
      dispatch(hideLoader());
    }
  };

  /* Interface action access from common access */
  useEffect(() => {
    let interfaceName = props?.hashArr[props?.selectedIndex];
    let actionAccess = accessRightActionCheck(aR.moduleName, interfaceName);
    setInterfaceActionAccessOverview(actionAccess);
  }, [props?.selectedIndex]);

  useEffect(() => {
    if (props.editData && props.productId) {
      getProductDetails();
    }
    return () => {};
  }, [props.editData, props.location.state]);

  useEffect(() => {
    if (props.location.state?.shouldRefresh) {
      getProductDetails();
    }
  }, []);
  console.log('productDetails?.productDocuments?.length',productDetails?.productDocuments?.length);
  
  return (
    <div className="taxonomy-form-container" style={{ height: "74vh", overflowY: "scroll" }}>
      <div className="flex flex-col m-3 w-auto border border-[#DBDBDD] company-product-overview">
        <Accordion
          sx={{
            backgroundColor: "white",
            margin: "0 !important",
            borderTop: "none",
            borderRadius: "0 !important",
            boxShadow: "none",
            "&.Mui-expanded": {
              margin: "0 !important",
              borderTop: "1px solid #e0e0e0",
            },
            "&:before": {
              display: "none",
            },
          }}
          className="!m-0"
          expanded={Object.keys(productDetails).length > 0 && expandedAccordions["productDescription"]}
          onChange={(event) => {
            event.stopPropagation();
            handleAccordionChange("productDescription");
          }}
        >
          <AccordionSummary
            className="w-full"
            sx={{
              flexDirection: "row-reverse",
              "&.Mui-expanded": {
                margin: "0",
                minHeight: "48px",
              },
              "& .MuiAccordionSummary-content": {
                flexGrow: 1,
                margin: 0,
                alignItems: "center",
              },
              "& .MuiAccordionSummary-expandIconWrapper": {
                marginLeft: "auto",
              },
              height: "60px",
              padding: "15px !important",
            }}
            aria-controls="panel1bh-content"
            id="panel1bh-header"
          >
            <Box className="w-full flex flex-col">
              <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                <Box sx={{ display: "flex", alignItems: "center", flexGrow: 1 }}>
                  {false ? (
                    <ErrorIcon color="warning" />
                  ) : (
                    <CheckCircleIcon
                      sx={{
                        color: Object.keys(productDetails).length > 0 ? "#0CB963 !important" : "action.disabled",
                        fontSize: "32px !important",
                      }}
                    />
                  )}
                  <Typography variant="h3" fontWeight="700" fontSize="16px" className="pl-2">
                    Product Detail & Description
                  </Typography>
                </Box>
                <Box sx={{ display: "flex", alignItems: "center", justifyContent: "flex-end" }}>
                  {accessActionSave && props.editData && Object.keys(productDetails).length > 0 ? (
                    <Button
                      variant="text"
                      sx={{
                        backgroundColor: "transparent",
                        color: "#F94F5E !important",
                        fontSize: "16px",
                        textTransform: "none",
                        textAlign: "center",
                        fontWeight: "400",
                        padding: "0 !important",
                      }}
                      onClick={(event) => {
                        event.stopPropagation();
                        setTimeout(() => {
                          history.push(`${split_url.join("/")}/product-detail-description/edit#overview`, {
                            companyId: props?.companyId,
                            productId: props?.productId,
                          });
                        }, 10);
                      }}
                    >
                      <ModeEditOutlineOutlinedIcon
                        sx={{ color: "#F94F5E", width: "20px !important", height: "20px !important", marginRight: "2px !important" }}
                      />{" "}
                      Edit Details
                    </Button>
                  ) : (
                    <Button
                      variant="text"
                      sx={{
                        backgroundColor: "transparent",
                        color: "#F94F5E !important",
                        fontSize: "16px",
                        textTransform: "none",
                        textAlign: "center",
                        fontWeight: "400",
                      }}
                      onClick={(event) => {
                        event.stopPropagation();
                        setTimeout(() => {
                          history.push(`${split_url.join("/")}/product-detail-description/add#overview`, {
                            companyId: props?.companyId,
                          });
                        }, 10);
                      }}
                    >
                      <AddIcon sx={{ color: "#F94F5E", width: "20px !important", height: "20px !important", marginRight: "2px !important" }} /> Add
                      New
                    </Button>
                  )}
                  {props?.editData && Object.keys(productDetails).length > 0 && (
                    <Button
                      variant="text"
                      sx={{ minWidth: "0 !important", padding: "6px 8px !important" }}
                      onClick={() => handleAccordionChange("productDescription")}
                    >
                      {expandedAccordions["productDescription"] ? (
                        <KeyboardArrowUpOutlinedIcon sx={{ color: "#000", fontSize: "30px !important" }} />
                      ) : (
                        <KeyboardArrowDownOutlinedIcon sx={{ color: "#000", fontSize: "30px !important" }} />
                      )}
                    </Button>
                  )}
                </Box>
              </Box>
            </Box>
          </AccordionSummary>
          {expandedAccordions["productDescription"] && (
            <AccordionDetails
              sx={{
                "& .form-group": {
                  marginBottom: "0 !important",
                },
              }}
            >
              <div className="product-details">
                <div className="d-flex fw-normal">
                  <div className="" style={{ minWidth: "15%", marginRight: "2rem" }}>
                    <p>Product Image</p>
                    <div className="d-flex align-items-center">
                      <a
                        href={fetchProductImageUrl(productDetails?.productProfileImage, productDetails?.productProfileImage)}
                        download
                        target="_blank"
                        rel="noreferrer"
                      >
                        <img src="/assets/download-icon.svg" alt="image-download" />
                        <span style={{ marginLeft: ".5rem" }}>{productDetails?.productProfileImage}</span>
                      </a>
                    </div>
                  </div>
                  <div className="" style={{ minWidth: "15%", marginRight: "2rem" }}>
                    <p>Product Name</p>
                    <span>{productDetails?.productName}</span>
                  </div>
                  <div className="" style={{ minWidth: "15%", marginRight: "2rem" }}>
                    <p>Year Launched</p>
                    <span>{productDetails?.productLaunchYear}</span>
                  </div>
                  <div className="" style={{ minWidth: "15%" }}>
                    <p>Technology Maturity Level</p>
                    <span>{productDetails?.productTechnologyMaturityLevel}</span>
                  </div>
                </div>
              </div>
            </AccordionDetails>
          )}
        </Accordion>

        <Accordion
          sx={{
            backgroundColor: "white",
            margin: "0 !important",
            borderTop: "1px solid #e0e0e0",
            borderBottom: "none",
            borderLeft: "none",
            borderRight: "none",
            borderRadius: "0 !important",
            boxShadow: "none",
            "&.Mui-expanded": {
              margin: "0 !important",
              borderTop: "1px solid #e0e0e0",
            },
            "&:before": {
              display: "none",
            },
          }}
          className="!m-0"
          expanded={productDetails?.productDocuments?.length > 0 && expandedAccordions["documents"]}
          onChange={() => handleAccordionChange("documents")}
          disabled={Object.keys(productDetails).length === 0}
        >
          <AccordionSummary
            className="w-full"
            sx={{
              flexDirection: "row-reverse",
              "&.Mui-expanded": {
                margin: "0",
                minHeight: "48px",
              },
              "& .MuiAccordionSummary-content": {
                flexGrow: 1,
                margin: 0,
                alignItems: "center",
              },
              "& .MuiAccordionSummary-expandIconWrapper": {
                marginLeft: "auto",
              },
              height: "60px",
              padding: "15px !important",
            }}
            aria-controls="panel1bh-content"
            id="panel1bh-header"
          >
            <Box className="w-full flex flex-col">
              <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                <Box sx={{ display: "flex", alignItems: "center", flexGrow: 1 }}>
                  {false ? (
                    <ErrorIcon color="warning" />
                  ) : (
                    <CheckCircleIcon
                      sx={{
                        color: productDetails?.productDocuments?.length > 0 ? "#0CB963 !important" : "action.disabled",
                        fontSize: "32px !important",
                      }}
                    />
                  )}
                  <Typography variant="h3" fontWeight="700" fontSize="16px" className="pl-2">
                    Documents/ Brochure
                  </Typography>
                  <span className="pl-2">(Maximum 10 files allowed)</span>
                </Box>
                <Box sx={{ display: "flex", alignItems: "center", justifyContent: "flex-end" }}>
                  <Button
                    variant="text"
                    sx={{
                      backgroundColor: "transparent",
                      color: "#F94F5E !important",
                      fontSize: "16px",
                      textTransform: "none",
                      fontWeight: "400",
                      textAlign: "center",
                      padding: "0 !important",
                                              "&:disabled": {
                          opacity: "0.5 !important ",
                          backgroundColor: "#DBDBDD",
                          color: "#FFFFFF",
                          cursor: "default !important",
                        },
                    }}
                    onClick={(event) => {
                      event.stopPropagation();
                      setTimeout(() => {
                        history.push(`${split_url.join("/")}/document/add#overview`, {
                          companyId: props?.companyId,
                          productId: props?.productId,
                        });
                      }, 10);
                    }}
                    disabled={productDetails?.productDocuments?.length === 10}
                  >
                    <AddIcon sx={{ color: "#F94F5E", width: "20px !important", height: "20px !important", marginRight: "2px !important" }} /> Add New
                  </Button>
                  {props.editData && Object.keys(productDetails).length > 0 && productDetails?.productDocuments?.length > 0 && (
                    <Button
                      variant="text"
                      sx={{ minWidth: "0 !important", padding: "6px 8px !important" }}
                      onClick={() => handleAccordionChange("documents")}
                    >
                      {expandedAccordions["documents"] ? (
                        <KeyboardArrowUpOutlinedIcon sx={{ color: "#000", fontSize: "30px !important" }} />
                      ) : (
                        <KeyboardArrowDownOutlinedIcon sx={{ color: "#000", fontSize: "30px !important" }} />
                      )}
                    </Button>
                  )}
                </Box>
              </Box>
            </Box>
          </AccordionSummary>
          {expandedAccordions["documents"] && (
            <AccordionDetails
              sx={{
                "& .form-group": {
                  marginBottom: "0 !important",
                },
              }}
            >
              <Box>
                <DocumentTable documentsList={productDetails?.productDocuments || []} {...props} />
              </Box>
            </AccordionDetails>
          )}
        </Accordion>

        <Accordion
          sx={{
            backgroundColor: "white",
            margin: "0 !important",
            borderTop: "1px solid #e0e0e0",
            borderBottom: "none",
            borderLeft: "none",
            borderRight: "none",
            borderRadius: "0 !important",
            boxShadow: "none",
            "&.Mui-expanded": {
              margin: "0 !important",
              borderTop: "1px solid #e0e0e0",
            },
            "&:before": {
              display: "none",
            },
          }}
          className="!m-0"
          expanded={productDetails?.productVideos?.length > 0 && expandedAccordions["videos"]}
          onChange={() => handleAccordionChange("videos")}
          disabled={Object.keys(productDetails).length === 0}
        >
          <AccordionSummary
            className="w-full"
            sx={{
              flexDirection: "row-reverse",
              "&.Mui-expanded": {
                margin: "0",
                minHeight: "48px",
              },
              "& .MuiAccordionSummary-content": {
                flexGrow: 1,
                margin: 0,
                alignItems: "center",
              },
              "& .MuiAccordionSummary-expandIconWrapper": {
                marginLeft: "auto",
              },
              height: "60px",
              padding: "15px !important",
            }}
            aria-controls="panel1bh-content"
            id="panel1bh-header"
          >
            <Box className="w-full flex flex-col">
              <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                <Box sx={{ display: "flex", alignItems: "center", flexGrow: 1 }}>
                  {false ? (
                    <ErrorIcon color="warning" />
                  ) : (
                    <CheckCircleIcon
                      sx={{
                        color:
                          Object.keys(productDetails).length > 0 && productDetails?.productVideos?.length > 0
                            ? "#0CB963 !important"
                            : "action.disabled",
                        fontSize: "32px !important",
                      }}
                    />
                  )}
                  <Typography variant="h3" fontWeight="700" fontSize="16px" className="pl-2">
                    Videos
                  </Typography>
                </Box>
                <Box sx={{ display: "flex", alignItems: "center", justifyContent: "flex-end" }}>
                  <Button
                    variant="text"
                    sx={{
                      backgroundColor: "transparent",
                      color: "#F94F5E !important",
                      fontSize: "16px",
                      textTransform: "none",
                      fontWeight: "400",
                      textAlign: "center",
                      padding: "0 !important",
                    }}
                    onClick={(event) => {
                      event.stopPropagation();
                      setTimeout(() => {
                        history.push(`${split_url.join("/")}/video/add#overview`, {
                          companyId: props?.companyId,
                          productId: props?.productId,
                        });
                      }, 10);
                    }}
                  >
                    <AddIcon sx={{ color: "#F94F5E", width: "20px !important", height: "20px !important", marginRight: "2px !important" }} /> Add New
                  </Button>
                  {props.editData && Object.keys(productDetails).length > 0 && productDetails?.productVideos?.length > 0 && (
                    <Button
                      variant="text"
                      sx={{ minWidth: "0 !important", padding: "6px 8px !important" }}
                      onClick={() => handleAccordionChange("videos")}
                    >
                      {expandedAccordions["videos"] ? (
                        <KeyboardArrowUpOutlinedIcon sx={{ color: "#000", fontSize: "30px !important" }} />
                      ) : (
                        <KeyboardArrowDownOutlinedIcon sx={{ color: "#000", fontSize: "30px !important" }} />
                      )}
                    </Button>
                  )}
                </Box>
              </Box>
            </Box>
          </AccordionSummary>
          {expandedAccordions["videos"] && (
            <AccordionDetails
              sx={{
                "& .form-group": {
                  marginBottom: "0 !important",
                },
              }}
            >
              <VideosTable videosList={productDetails?.productVideos || []} {...props} />
            </AccordionDetails>
          )}
        </Accordion>

        <Accordion
          sx={{
            backgroundColor: "white",
            margin: "0 !important",
            borderTop: "1px solid #e0e0e0",
            borderBottom: "none",
            borderLeft: "none",
            borderRight: "none",
            borderRadius: "0 !important",
            boxShadow: "none",
            "&.Mui-expanded": {
              margin: "0 !important",
              borderTop: "1px solid #e0e0e0",
            },
            "&:before": {
              display: "none",
            },
          }}
          className="!m-0"
          expanded={productDetails?.productImages?.length > 0 && expandedAccordions["images"]}
          onChange={() => handleAccordionChange("images")}
          disabled={Object.keys(productDetails).length === 0}
        >
          <AccordionSummary
            className="w-full"
            sx={{
              flexDirection: "row-reverse",
              "&.Mui-expanded": {
                margin: "0",
                minHeight: "48px",
              },
              "& .MuiAccordionSummary-content": {
                flexGrow: 1,
                margin: 0,
                alignItems: "center",
              },
              "& .MuiAccordionSummary-expandIconWrapper": {
                marginLeft: "auto",
              },
              height: "60px",
              padding: "15px !important",
            }}
            aria-controls="panel1bh-content"
            id="panel1bh-header"
          >
            <Box className="w-full flex flex-col">
              <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                <Box sx={{ display: "flex", alignItems: "center", flexGrow: 1 }}>
                  {false ? (
                    <ErrorIcon color="warning" />
                  ) : (
                    <CheckCircleIcon
                      sx={{
                        color:
                          Object.keys(productDetails).length > 0 && productDetails?.productImages?.length > 0
                            ? "#0CB963 !important"
                            : "action.disabled",
                        fontSize: "32px !important",
                      }}
                    />
                  )}
                  <Typography variant="h3" fontWeight="700" fontSize="16px" className="pl-2">
                    Images
                  </Typography>
                </Box>
                <Box sx={{ display: "flex", alignItems: "center", justifyContent: "flex-end" }}>
                  <Button
                    variant="text"
                    sx={{
                      backgroundColor: "transparent",
                      color: "#F94F5E !important",
                      fontSize: "16px",
                      textTransform: "none",
                      fontWeight: "400",
                      textAlign: "center",
                      padding: "0 !important",
                    }}
                    onClick={(event) => {
                      event.stopPropagation();
                      setTimeout(() => {
                        history.push(`${split_url.join("/")}/image/add#overview`, {
                          companyId: props?.companyId,
                          productId: props?.productId,
                        });
                      }, 10);
                    }}
                  >
                    <AddIcon sx={{ color: "#F94F5E", width: "20px !important", height: "20px !important", marginRight: "2px !important" }} /> Add New
                  </Button>
                  {props.editData && Object.keys(productDetails).length > 0 && productDetails?.productImages?.length > 0 && (
                    <Button
                      variant="text"
                      sx={{ minWidth: "0 !important", padding: "6px 8px !important" }}
                      onClick={() => handleAccordionChange("images")}
                    >
                      {expandedAccordions["images"] ? (
                        <KeyboardArrowUpOutlinedIcon sx={{ color: "#000", fontSize: "30px !important" }} />
                      ) : (
                        <KeyboardArrowDownOutlinedIcon sx={{ color: "#000", fontSize: "30px !important" }} />
                      )}
                    </Button>
                  )}
                </Box>
              </Box>
            </Box>
          </AccordionSummary>
          {expandedAccordions["images"] && (
            <AccordionDetails
              sx={{
                "& .form-group": {
                  marginBottom: "0 !important",
                },
              }}
            >
              <ImageTable imagesList={productDetails?.productImages || []} {...props} />
            </AccordionDetails>
          )}
        </Accordion>
      </div>

      <div className="form-submit-box">
        <div className="footer-layout">
          {props.productId !== "" && props.selectedIndex > -1 ? (
            <button
              type="button"
              className="btn btn-outline-dark company-button"
              onClick={() => {
                props.selectedIndex < 5 && props.setCurrentTab(props.selectedIndex + 1);
              }}
            >
              Next
            </button>
          ) : null}
        </div>
        <div className="footer-layout">
          <button
            type="button"
            onClick={(e) => {
              e.preventDefault();
              history.push(props.backPath, {
                companyId: props.companyId,
              });
            }}
            className="btn btn-outline-dark company-button"
          >
            Cancel
          </button>

          {accessActionSubmit ? (
            <button
              type="button"
              className="btn btn-primary company-button"
              onClick={() => {
                saveProductData();
              }}
            >
              Save
            </button>
          ) : null}
          {accessActionFinalSubmit ? (
            <button
              type="button"
              className="btn btn-primary company-button"
              onClick={() => {
                onFinalSaveProcessingData();
              }}
            >
              Submit
            </button>
          ) : null}
          {/* {accessActionPublish ? <ProductDataPublicUI productId={props.productId} /> : null} */}
          {/* {props.path == "/processing/company/:companyId/product/:productId/edit" ? <RemarkListProduct productId={props.productId} /> : null} */}
        </div>
      </div>
    </div>
  );
};

export default memo(ProductOverview);

ProductOverview.propTypes = {
  location: PropTypes.object.isRequired,
  productId: PropTypes.string,
  editData: PropTypes.bool.isRequired,
  onSaveProcessingData: PropTypes.func.isRequired,
  onFinalSaveProcessingData: PropTypes.func.isRequired,
  onSaveData: PropTypes.func.isRequired,
  onUpdateData: PropTypes.func.isRequired,
  accessRights: PropTypes.object,
  selectedIndex: PropTypes.number,
  setCurrentTab: PropTypes.func,
  path: PropTypes.string,
  hashArr: PropTypes.array,
  backPath: PropTypes.string,
  companyId: PropTypes.string,
  computedMatch: PropTypes.object,
};
